<template>
  <div>
    <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
      <div class="content">
        <section class="section--sidebar-user">
          <section class="section--title-sidebar">
            <h3>{{groupQuestion}}</h3>
          </section>
          
          <section class="section--content-sidebar section--content-sidebar-full-height">
          <div class="row" v-for="(question,index) in questions">
              <div class="col-1">
                  <button class="btn btn--danger" @click="deleteQuestion(index)">
                      <i class="fas fa-trash"></i>
                  </button>
              </div>
              <div class="col-10">
                  <input type="text" v-model="question[lang]" class="form-control" @change="saveQuestions()">
              </div>
          </div>
          <div class="form-group">
              <label>Nuova domanda</label>
              <input type="text" class="form-control" v-model="newQuestion">
              <a class="btn btn--blue" @click="createQuestions()"> <i class="fas fa-plus"></i>Nuova domanda</a>
          </div>
          </section>
        </section>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {

  props: {
    satisfaction_survey : {
      type:Number,
      required: true
    },
  },
  data () {
    return {
      sectorIndex : null,
      keyGroup : null,
      questions : [],
      lang      : "it",
      groupQuestion : "",
      newQuestion : "",
      //default
      title: "Matrix",
      active : false,
    }
  },
  methods: {
    confirm(){
      Vue.$toast.open({
        message: 'Save Complete!',
        type: 'success',
        position: 'top-right'
      });  
    },
    deleteQuestion(index){
      axios.delete("/delete-satisfaction-survey-settings-question/"+this.satisfaction_survey,{
        params: {
          sectorIndex : this.sectorIndex,
          keyGroup : this.keyGroup,
          questionIndex : index,
        }
      })
      .then((response) => {
          this.getQuestions();
          this.confirm();
      });
    },
    createQuestions(){
      axios.post(("/store-satisfaction-survey-settings-question/"+this.satisfaction_survey),  {
        sectorIndex           : this.sectorIndex,
        keyGroup              : this.keyGroup,
        questionTxt           : this.newQuestion,
      }).then((response) => {
        this.newQuestion = "";
        this.getQuestions();
        this.confirm();
      }).catch(function(error){
        alert(error);
      });
    },
    saveQuestions(){

      axios.put(("/save-satisfaction-survey-settings-question/"+this.satisfaction_survey),  {
        sectorIndex           : this.sectorIndex,
        keyGroup              : this.keyGroup,
        questions             : this.questions,
      }).then((response) => {
        this.getQuestions();
        this.confirm();
      }).catch(function(error){
        alert(error);
      });
    },
    getQuestions(){
      let dataRoute   = "/get-satisfaction-survey-question-settings/"+this.satisfaction_survey;
      axios.get(dataRoute,{
        params: {
          sectorIndex : this.sectorIndex,
          keyGroup : this.keyGroup
        }
      })
          .then((response) => {
            this.questions = (response.data.questions);
            this.lang =  (response.data.lang);
          });
    },

    toggle(sectorIndex,keyGroup,groupQuestion) {

      this.active     = true;
      this.sectorIndex = sectorIndex;
      this.keyGroup = keyGroup;
      this.groupQuestion = groupQuestion;
      this.getQuestions();

    }

  }

}
</script>
<style>
.hidden {
  display: none !important;
}
</style>

